/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number3SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path
			fill="white"
			d="M11.27 19.62C12.42 20.82 14.25 21.52 15.88 21.52C17.91 21.52 19.03 20.64 19.03 19.37C19.03 18.02 18 17.39 15.68 17.39C14.98 17.39 13.85 17.39 13.6 17.41V14.31C13.9 14.34 15.03 14.34 15.68 14.34C17.53 14.34 18.76 13.74 18.76 12.49C18.76 11.16 17.41 10.49 15.66 10.49C14.03 10.49 12.58 11.12 11.4 12.24L9.64999 10.04C11 8.51001 13.1 7.39001 16.03 7.39001C19.94 7.39001 22.34 9.14001 22.34 11.92C22.34 14.02 20.54 15.4 18.68 15.73C20.38 15.9 22.59 17.23 22.59 19.74C22.59 22.62 20.01 24.65 16.01 24.65C12.93 24.65 10.65 23.47 9.42999 21.97L11.28 19.64L11.27 19.62Z"
		/>
	</>
);

export default Number3SansDark;
